export default {
  name: 'top100',
  path: '/top100',
  loadComponent: () => import('./index')
};
